<template>
  <div
    class="grid grid-cols-3 py-12 md:px-24 text-body-2 text-static-default-hi"
  >
    <div class="flex flex-col items-center px-16">
      <IconTruck class="m-12" size="24" />
      <div class="text-center">
        <FormattedMessage
          v-if="dates.free"
          :definition="translations.freeShipping"
        >
          <template #dates>
            <span data-allow-mismatch="text">
              {{
                i18n(translations.freeShippingDates, {
                  earliest: dates.free.earliest,
                  latest: dates.free.latest,
                })
              }}
            </span>
          </template>
        </FormattedMessage>

        <span v-else>
          {{ i18n(translations.freeShippingWithoutDates) }}
        </span>
      </div>
    </div>

    <div class="flex flex-col items-center px-16">
      <IconCycle class="m-12" size="24" />
      <div class="text-center">
        {{ i18n(translations.thirtyDaysReturns) }}
      </div>
    </div>

    <div class="flex flex-col items-center px-16">
      <IconQuality class="m-12" size="24" />
      <div class="text-center">
        {{ i18n(translations.free1YearWarranty) }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconCycle } from '@ds/icons/IconCycle'
import { IconQuality } from '@ds/icons/IconQuality'
import { IconTruck } from '@ds/icons/IconTruck'

import { useDeliveryDatesFromShipping } from '~/scopes/shipping/composables/useDeliveryDatesFromShipping/useDeliveryDatesFromShipping'

import translations from './USRefurbProcessReassuranceItems.translations'

const props = defineProps<{
  shipping: NonNullable<GetPickersResponse['selectedOffer']>['shipping']
}>()

const dates = useDeliveryDatesFromShipping(() => props.shipping)

const i18n = useI18n()
</script>
